import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { useUiVersion } from 'hooks';
import { user } from 'services';
import { Popup } from 'libs/ui';
import { getRules } from 'store/ducks/models/rules';
import { ZonesRow } from './zones-row';
import { RulesRow } from './rules-row';
import { RulesCard } from './card/rules-card';
import { Content, HeaderRow, RulesContent, ScrollWrapper } from './rules.styled';

export const Rules = () => {
  const { t } = useTranslation();
  const { isNew } = useUiVersion();

  const dispatch = useDispatch();
  const rules = useSelector((store) => store.rules.rules);
  const [popup, setPopup] = useState(false);
  const [item, setItem] = useState({});
  const [rule_id, setRuleId] = useState('');

  useEffect(() => {
    dispatch(getRules());
  }, []);

  const showPopup = (item, rule_id) => {
    setPopup(true);
    setItem(item);
    setRuleId(rule_id);
  };

  const closePopup = () => {
    setPopup(false);
  };

  const getRulesList = (type) => {
    const rightView = user.haveRight('rules.view');
    return rules.filter((item) => item.type === type).map((item) => <RulesRow key={'rule-' + item.rule_id} {...item} action={rightView ? showPopup : () => null} disabled={!rightView} />);
  };

  const refresh = () => {
    dispatch(getRules());
    closePopup();
  };

  if (!rules || !rules.length) {
    return null;
  }

  let rule, title;
  if (popup) {
    rule = rules.find((el) => el.rule_id === rule_id);
    title = rule.name;
  }

  return (
    <Content>
      <RulesContent>
        <ZonesRow rules={rules} />
        <HeaderRow>
          <span>{t('sections.Категории ТС')}</span>
        </HeaderRow>
        <ScrollWrapper>{getRulesList('category')}</ScrollWrapper>
        <ZonesRow rules={rules} />
        <HeaderRow>
          <span>{t('sections.Классы ТС')}</span>
        </HeaderRow>
        <ScrollWrapper>{getRulesList('class')}</ScrollWrapper>
      </RulesContent>

      {popup && (
        <Popup cache={item.zone_id + '_' + rule_id} rule={rule} theme={isNew ? undefined : 'dark'} title={title} close={closePopup}>
          <RulesCard item={item} rule={rule} refresh={refresh} />
        </Popup>
      )}
    </Content>
  );
};
